/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import { Box, Flex } from '@chakra-ui/react'
import React from 'react'
import DatePicker from 'react-datepicker'
import './index.scss'
import dayjs from 'dayjs'
import { MdOutlineDateRange } from 'react-icons/md'

interface IInputGroup {
  width?: string
  placeholder?: string
  value?: Date
  onChange: (param: Date) => void
}

function DateTimeField({ value, onChange, width, placeholder }: IInputGroup) {
  return (
    <Box flex={2} width={width} className="date-box">
      <Flex alignItems="center">
        <DatePicker
          selected={value}
          onChange={onChange}
          timeInputLabel="Time:"
          dateFormat="dd/MM/yyyy HH:mm"
          placeholderText={placeholder}
          showTimeInput
          isClearable
        />
        <MdOutlineDateRange className="icon-date-range" />
      </Flex>
    </Box>
  )
}

DateTimeField.defaultProps = {
  id: '',
  width: 'auto',
  value: dayjs().toDate()
}

export default DateTimeField
